export interface MenuItem {
    name: string;
    icon: string;
    path?: string;
    details?: string;
    isSubmenu?: boolean;
    childs?: MenuItem[];
}

export const MAIN_MENU: MenuItem[] = [
    {
        name: 'Cadastros',
        icon: 'archive',
        childs: [
            { name: 'Produtor', icon: 'person', path: '/producers' },
            { name: 'Controlador', icon: 'badge', path: '/controller' },
            { name: 'Reprodutores', icon: 'pets', path: '/breeders' },
        ],
    },
    {
        name: 'Integrações',
        icon: 'sync_alt',
        childs: [
            { name: 'SRG-SCL', icon: 'settings', path: '/integration-settings' },
            { name: 'Monitoramento', icon: 'monitor_heart', path: '/integration-monitor' },
            { name: 'Auditoria de ajustes', icon: 'fact_check', path: '/adjustments-audit' },
        ],
    }
];
